<div class="state-page">
  <div class="state-card">
    <img src="./assets/logos/Primary_Logo_Positive.svg" alt="Maersk" class="state-logo" />
    <p class="state-appname">Oil Analysis</p>
    <div class="state-icon-badge">
      <mc-icon icon="shield-lock" size="24" color="#B80012"></mc-icon>
    </div>
    <h1 class="state-title">Unauthorized Access</h1>
    <p class="state-message">
      We couldn't verify your access to this application. You may not be authorized, or your session could not be
      validated. Please try again or contact your application administrator for access.
    </p>
    <div class="state-actions">
      <mc-button label="Back to Login" appearance="primary" variant="filled" (click)="login()"></mc-button>
    </div>
  </div>
</div>
